module.exports = __webpack_public_path__ + "static/img/sample-pic5.e62ff30e.png";